export default function XHRFetch(type, url, options, headers = {}) {
    return new Promise(function (resolve, reject) {
        // Do the usual XHR stuff
        var req = new XMLHttpRequest();
        req.open(type, url);

        for (const hdr in headers) {
            req.setRequestHeader(hdr, headers[hdr]);
        }
        req.onload = function () {
            if (req.status === 200 || req.status === 201) {
                // Resolve the promise with the response text
                setTimeout(() => resolve(req), 0);
            } else {
                // Otherwise reject with the status text
                // which will hopefully be a meaningful error
                console.log(req.response);
                reject(Error(req.response));
            }
        };
        req.onerror = function () {
            const errorMessage = {
                error_codes: [],
                status: req.status,
            };
            console.log('Fetch error. Status: ' + req.status);
            reject(Error(JSON.stringify(errorMessage)));
        };
        req.send(options);
    });
}
